import { Widget } from "@merge-api/merge-javascript-shared/dist/designSystem/molecules/ChatWidget/Widget";
import { dropMessages } from "@merge-api/merge-javascript-shared/dist/designSystem/molecules/ChatWidget/api";
import { useBpeConversation } from "../hooks/useBpeConversation";
import "../../../../styles/css/chat_bpe.css";
import { useEffect } from "react";
import { Blueprint } from "../../../../models/Blueprints";
import { createMessageToolsFactory } from "./MessageToolsFactory";

export function BlueprintChatWidget({
  doesBlueprintHaveUnsavedChanges,
  blueprint,
  isUsingCustomerLinkedAccount,
}: {
  doesBlueprintHaveUnsavedChanges: boolean;
  blueprint: Blueprint;
  isUsingCustomerLinkedAccount: boolean;
}) {
  const { send } = useBpeConversation(
    doesBlueprintHaveUnsavedChanges,
    blueprint,
    isUsingCustomerLinkedAccount
  );

  // hook where we drop current messages
  useEffect(() => {
    // 1. Drop messages immediately if blueprint changes (optional)
    dropMessages();

    // 2. Before the browser unloads, drop messages too
    const handleBeforeUnload = () => {
      dropMessages();
    };
    window.addEventListener("beforeunload", handleBeforeUnload);

    // 3. Cleanup: on component un‐mount or blueprint change,
    //    remove listener and drop messages one last time
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      dropMessages();
    };
  }, [blueprint.id]);

  const handleNewUserMessage = async (text: string): Promise<string | void> => {
    return send(text);
  };

  // Create message tools factory with blueprint context and sessionId for feedback tracking
  const messageToolsFactory = createMessageToolsFactory();

  return (
    <Widget
      handleNewUserMessage={handleNewUserMessage}
      title="ChatBPE"
      subtitle="The Merge way: Today, not tomorrow!"
      senderPlaceHolder="Ask about this blueprint... REMINDER: DO NOT INPUT CUSTOMER DATA OR SENSITIVE INFORMATION INTO CHATBPE"
      createMessageTools={messageToolsFactory}
    />
  );
}
